module.exports = __webpack_public_path__ + "static/media/load-credit-icon.1865ddb5.svg";